import Box from "@mui/material/Box";
import React from "react";

import {
  HEIGHT_OPTION,
  NOTE,
  boxKey,
  formKey,
  useQuoteBoxStructure,
} from "../../../hooks/useQuoteBoxStructure";
import { DoorRow } from "./BoxStructureDoors";
import {
  CardRow,
  CheckboxNote,
  FieldsRow,
  OptionCard,
  OptionCheckbox,
  OptionHeader,
  StructureCard,
  StructureSection,
  TypeHeightRow,
} from "./BoxStructureFields";
import { NoteField, NumberedSectionTitle } from "./FormFields";
import { useStyles } from "../styles";

const BoxStructure = () => {
  const styles = useStyles();
  const { data, patch } = useQuoteBoxStructure();
  const { frontWall, backWall, frontRack, backRack } = data;

  return (
    <Box className={styles.inputCard}>
      <NumberedSectionTitle
        number={3}
        titleKey={formKey("SECTIONS.BOX_STRUCTURE")}
      />

      <StructureSection titleKey={boxKey("SECTIONS.WALLS")} plain>
        <StructureCard
          enabled={frontWall.enabled}
          titleKey={boxKey("CARDS.FRONT_WALL")}
          onToggle={(enabled) => patch("frontWall", { enabled })}
        >
          <TypeHeightRow
            typeValue={frontWall.selectedOption}
            heightValue={frontWall.height}
            onTypeChange={(selectedOption) =>
              patch("frontWall", { selectedOption })
            }
            onHeightChange={(height) => patch("frontWall", { height })}
          />
          <FieldsRow>
            <CheckboxNote
              checkboxLabelKey={boxKey("FIELDS.TREAD_SURFACE")}
              checked={frontWall.treadSurface}
              note={frontWall.treadNote}
              onCheck={(treadSurface) => patch("frontWall", { treadSurface })}
              onNote={(treadNote) => patch("frontWall", { treadNote })}
            />
            <CheckboxNote
              checkboxLabelKey={boxKey("FIELDS.WIDTH_REINFORCEMENT")}
              checked={frontWall.widthReinforcement}
              note={frontWall.widthNote}
              onCheck={(widthReinforcement) =>
                patch("frontWall", { widthReinforcement })
              }
              onNote={(widthNote) => patch("frontWall", { widthNote })}
              title
            />
          </FieldsRow>
        </StructureCard>

        <CardRow>
          <OptionCard enabled={frontRack.enabled || backRack.enabled}>
            <OptionHeader
              labelKey={boxKey("CARDS.FRONT_RACK")}
              checked={frontRack.enabled}
              onChange={(enabled) => patch("frontRack", { enabled })}
            />
            <NoteField
              labelKey={HEIGHT_OPTION}
              value={frontRack.location}
              onChange={(location) => patch("frontRack", { location })}
            />
            <OptionHeader
              labelKey={boxKey("CARDS.BACK_RACK")}
              checked={backRack.enabled}
              onChange={(enabled) => patch("backRack", { enabled })}
            />
            <FieldsRow>
              <NoteField
                labelKey={HEIGHT_OPTION}
                value={backRack.location}
                onChange={(location) => patch("backRack", { location })}
                grow
              />
              <NoteField
                labelKey={NOTE}
                placeholderKey={NOTE}
                value={backRack.note}
                onChange={(note) => patch("backRack", { note })}
                grow
              />
            </FieldsRow>
          </OptionCard>

          <StructureCard
            enabled={backWall.enabled}
            titleKey={boxKey("CARDS.BACK_WALL")}
            onToggle={(enabled) => patch("backWall", { enabled })}
          >
            <TypeHeightRow
              typeValue={backWall.selectedOption}
              heightValue={backWall.size}
              onTypeChange={(selectedOption) =>
                patch("backWall", { selectedOption })
              }
              onHeightChange={(size) => patch("backWall", { size })}
            />
            <OptionCheckbox
              labelKey={boxKey("FIELDS.WIDTH_REINFORCEMENT")}
              checked={backWall.optionEnabled}
              onChange={(optionEnabled) =>
                patch("backWall", { optionEnabled })
              }
              title
            />
            <NoteField
              labelKey={NOTE}
              placeholderKey={NOTE}
              value={backWall.note}
              onChange={(note) => patch("backWall", { note })}
            />
          </StructureCard>
        </CardRow>
      </StructureSection>

      <StructureSection titleKey={boxKey("SECTIONS.DOORS")}>
        <DoorRow keys={["pillars", "sideDoors"]} />
        <DoorRow keys={["rearDoor", "hydraulicSide"]} />
      </StructureSection>
    </Box>
  );
};

export default BoxStructure;
